import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getEquipementListApi } from "../services/equipementService";

export const fetchEquipmentList = createAsyncThunk(
  "equipment/fetchList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getEquipementListApi();
      return res.data.items ?? [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ?? "Failed to load equipment list."
      );
    }
  }
);

const equipmentSlice = createSlice({
  name: "equipment",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearEquipmentError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEquipmentList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEquipmentList.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchEquipmentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearEquipmentError } = equipmentSlice.actions;
export default equipmentSlice.reducer;

export const selectEquipmentItems = (state) => state.equipment.items;
export const selectEquipmentLoading = (state) => state.equipment.loading;
export const selectEquipmentError = (state) => state.equipment.error;
